<div class="container">
  <div *ngIf="isCreateLoading" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
    <h1 class="page-title"
      [helpCenterButton]="editPermissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="editPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-pallet"></i></span>{{ 'CreateDo.Header' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.CreateHeader' | translate }}" [selected]="isFormOpen">
        <form [formGroup]="createDoForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-3 mb-3">
               <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{ 'CreateDo.CreateForm.Plant' | translate }}</p>
              <laas-plant-dropdown
                [isSingle]="true"
                formControlName="plant"
                (onOptionDataChange)="createDoRequest.plant = $event; onPlantChange({ value: $event })">
              </laas-plant-dropdown>
                <div *ngIf="((submitted || createDoForm.controls.plant.touched) && createDoForm?.controls?.plant?.errors?.required )" >
                  <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">{{ 'CreateDo.CreateForm.Facility' | translate }}</p>
              <div class="item">{{createDoRequest.facility}}</div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">{{ 'CreateDo.CreateForm.Storer' | translate }}</p>
              <div class="item">{{createDoRequest.storer}}</div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{ 'CreateDo.CreateForm.DeliveryType' | translate }}</p>
              <p-dropdown formControlName="deliveryType" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [(ngModel)]="createDoRequest.deliveryType" [options]="deliveryTypeOptions" appendTo="body"></p-dropdown>
                <div *ngIf="((submitted || createDoForm.controls.deliveryType.touched) && createDoForm?.controls?.deliveryType?.errors?.required )" >
                  <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                </div>
            </div>

            <!--Consignee系列會自動帶入-->
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{ 'CreateDo.CreateForm.ConsigneeKey' | translate }}</p>
              <p-dropdown formControlName="consigneeKey"  [(ngModel)]="createDoRequest.consigneeKey" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="consigneeKeyOptions" (onChange)="onConsigneeChange($event)"></p-dropdown>
              <div *ngIf="((submitted || createDoForm.controls.consigneeKey.touched) && createDoForm?.controls?.consigneeKey?.errors?.required )" >
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{ 'CreateDo.CreateForm.SpecLocType' | translate }}</p>
              <p-dropdown formControlName="specLocType"
                          [(ngModel)]="createDoRequest.specLocType"
                          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                          [options]="specLocTypeOptions"
                          (onChange)="onSpecLocTypeChange($event)"></p-dropdown>
              <div *ngIf="((submitted || createDoForm.controls.specLocType.touched) && createDoForm?.controls?.specLocType?.errors?.required )" >
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">{{ "CreateDo.CreateForm.CTN" | translate }}</p>
              <p-checkbox formControlName="ctn" [(ngModel)]="ctn" [binary]="true"></p-checkbox>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{ "CreateDo.CreateForm.MaterialCategory" | translate }}</p>
              <div>
              <p-radioButton formControlName="notes" name="notes" value="BF" label="BF" [(ngModel)]="createDoRequest.notes"></p-radioButton>
              <p-radioButton formControlName="notes" name="notes" value="DIP" label="DIP" [(ngModel)]="createDoRequest.notes" class="ml-2"></p-radioButton>
              <p-radioButton formControlName="notes" name="notes" value="MO" label="MO" [(ngModel)]="createDoRequest.notes" class="ml-2"></p-radioButton>
              <div *ngIf="((submitted || createDoForm.controls.notes.touched) && createDoForm?.controls?.notes?.errors?.required )" >
                <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
              </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{ "CreateDo.CreateForm.CalloffReason" | translate }}</p>
              <p-dropdown formControlName="calloffReason"
                          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                          [(ngModel)]="createDoRequest.calloffReason"
                          [options]="calloffReasonOptions"
                          (onChange)="onCalloffReasonChange($event)"
                          appendTo="body"></p-dropdown>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">{{ 'CreateDo.CreateForm.ConsigneeCompany' | translate }}</p>
              <div class="item">{{createDoRequest.consigneeCompany}}</div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">{{ 'CreateDo.CreateForm.ConsigneeAddress1' | translate }}</p>
              <div class="item">{{createDoRequest.consigneeAddress1}}</div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">{{ 'CreateDo.CreateForm.ConsigneeAddress2' | translate }}</p>
              <div class="item">{{createDoRequest.consigneeAddress2}}</div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-1">{{ "CreateDo.CreateForm.AsnNo" | translate }}</p>
              <laas-input id="asnNo"
                [parentFormGroup]="createDoForm"
                [controlName]="'asnNo'"
                [toUppercase]="true"
                [invalidCondition]="createDoForm.controls['asnNo'].invalid && createDoForm.controls['asnNo'].touched">
              </laas-input>
              <div *ngIf="createDoForm.controls['asnNo'].invalid && createDoForm.controls['asnNo'].touched">
                <small
                  *ngIf="createDoForm?.controls?.asnNo?.errors?.maxlength" class="p-invalid">
                  {{ 'CreateDo.Msg.AsnNoOverMaxLength' | translate }}
                </small>
                <small
                  *ngIf="createDoForm?.controls?.asnNo?.errors?.pattern" class="p-invalid">
                  {{ 'Common.Message.AllowedCharacterOnlyLettersNumberAndDash' | translate }}
                </small>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <laas-calendar
                #etd
                [title]="'CreateDo.CreateForm.ETD'"
                [enableMaxDateIsToday]="false"
                [selectionMode]="'single'"
                [minDate]="today"
                (onDateChange)="dateOnChange($event,'etd')">
              </laas-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <laas-calendar
                #eta
                [title]="'CreateDo.CreateForm.ETA'"
                [enableMaxDateIsToday]="false"
                [selectionMode]="'single'"
                [minDate]="today"
                (onDateChange)="dateOnChange($event,'eta')">
              </laas-calendar>
              <small
                *ngIf="createDoForm?.controls?.eta?.value && createDoForm?.controls?.etd?.value && createDoForm?.controls?.eta?.value < createDoForm?.controls?.etd?.value" class="p-invalid">
                {{ 'CreateDo.Msg.EtaCannotBeBeforeEtd' | translate }}
              </small>
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
            </div>

            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <p class="mt-0 mb-2">{{ "CreateDo.CreateForm.IsUrgent" | translate }}</p>
              <p-checkbox formControlName="priority" [(ngModel)]="priority" [binary]="true"  (onChange)="onPriorityChange($event)"></p-checkbox>
            </div>

            <ng-container *ngIf="priority">
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <p class="mt-0 mb-2">{{ "CreateDo.CreateForm.UrgentType" | translate }}</p>
                <p-dropdown formControlName="urgentType"
                            placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                            [(ngModel)]="createDoRequest.urgentType"
                            [options]="urgentOptions"
                            appendTo="body"></p-dropdown>
              </div>

              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{ "CreateDo.CreateForm.UrgentReason" | translate }}</p>
                <input id="urgentReason" type="text" pInputText formControlName="urgentReason"
                  [(ngModel)]="createDoRequest.urgentReason"
                  [class]="(priority && createDoForm.controls.urgentReason.errors) ? ['ng-invalid', 'ng-dirty'] : []" />
                <small *ngIf="priority && createDoForm.controls.urgentReason.errors" class="errors">
                  <div *ngIf="createDoForm.controls.urgentReason.errors.required" class="p-invalid">{{
                    'CreateDo.CreateForm.UrgentReason' | translate }} is required</div>
                </small>
              </div>

            </ng-container>

          </div>
        </form>

        <div class="flex justify-content-between align-items-center mb-3">
          <div class="flex align-items-center">
            <button pButton pRipple label="{{ 'CreateDo.Button.ImportExcel' | translate }}" icon="pi pi-upload" (click)="showImportDialog()" class="mr-2"></button>
            <button pButton pRipple label="{{ 'CreateDo.Button.CreateDo' | translate }}" (click)="createDo()" class="p-button-primary mr-2"></button>
            <i class="pi pi-cog settings-icon" (click)="showSettingsDialog()"></i>
          </div>
        </div>

      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        #createMoItemTable
        [defaultColumns]="createMoItemColumns"
        [editPermission]="editPermissionCode"
        [value]="createMoItemRequest"
        [isShowSaveFunction]="false"
        [inputValid]="dataInputValid"
        [createNewRow]="createNewRow"
        [dataKey]="'rowId'"
        [tableKey]="preferenceKey"
        [paginator]="false">

        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchDefault>
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>

        <!--Input-->
        <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col" let-rowIndex="rowIndex">
          <ng-container [ngSwitch]="getColumnType(col)">
            <ng-container *ngSwitchCase="'action'">
              <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text"
                      (click)="deleteRow(rowData)"></button>
            </ng-container>

            <ng-container *ngSwitchCase="'text'" class="p-fluid">
              <input type="text"  [(ngModel)]="rowData[col.field]" (input)="col.field === 'sku' ? onSkuInput($event, rowData) : null" pInputText>
              <small *ngIf="isCellRequired(col, rowData)" class="alert">
                <div class="p-invalid">
                  {{ 'Common.Button.Required' | translate }}
                </div>
              </small>
              <small *ngIf="showFieldConstraint(col)" class="remind">
                <div class="p-invalid">
                  {{ 'CreateDo.Msg.FieldAConstraint' | translate }}
                </div>
              </small>
            </ng-container>

            <ng-container *ngSwitchCase="'number'" class="p-fluid">
              <input type="number"  [(ngModel)]="rowData[col.field]" pInputText [readonly]="!getCellViewModel(rowData, col).editable">
              <small *ngIf="isColumnRequired(col) && !rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ 'Common.Button.Required' | translate }}
                </div>
              </small>
            </ng-container>

            <ng-container *ngSwitchCase="'dropdown'" class="p-fluid">
              <p-dropdown
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate }}"
                  [options]="getDropdownOptions(col)"
                  [showClear]="true"
                  appendTo="body"
                  [itemSize]="30"
                  [virtualScroll]="true"
                  [(ngModel)]="rowData[col.field]"
                  class="p-fluid"
                ></p-dropdown>
            </ng-container>

            <ng-container *ngSwitchCase="'bbp'" class="p-fluid">
              <ng-container *ngIf="getCellViewModel(rowData, col) as vm">
                <input *ngIf="vm.editable" type="text" [(ngModel)]="rowData[col.field]" pInputText>
                <div *ngIf="!vm.editable" class="readonly-text">{{ vm.visible ? (vm.value | replaceNullWith : "-") : "" }}</div>
              </ng-container>
            </ng-container>

            <ng-container *ngSwitchDefault class="p-fluid">
              <div class="overflow-text">
                {{ getColumnType(col) === 'bbp' && !(getCellViewModel(rowData, col).visible) ? "" : (rowData[col.field] | replaceNullWith : "-") }}
              </div>
            </ng-container>

          </ng-container>
        </ng-template>
        <!--Output-->
        <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ getColumnType(col) === 'bbp' && !(getCellViewModel(rowData, col).visible) ? "" : (rowData[col.field] | replaceNullWith : "-") }}
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>

<p-dialog p-dialog header="{{ 'CreateDo.Msg.CreateDOresult' | translate }}"
  appendTo="body"
  [(visible)]="isShowCreateDOResult"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{width: '25%'}"
  max-height="500"
  >
  <div class="p-fluid formgrid grid">
    <div class="field col-12">
      <label *ngIf="successfulDoNo && successfulDoNo.length > 0">
        {{ 'CreateDo.Msg.SuccessDORecords' | translate }}: {{successfulDoNo.length}}</label>
      <br *ngIf="successfulDoNo && successfulDoNo.length > 0">

      <label *ngIf="successfulDoNo && successfulDoNo.length > 0">
        {{ 'CreateDo.Msg.SuccessDONo' | translate }}: {{successfulDoNo}}</label>
      <br *ngIf="successfulDoNo && successfulDoNo.length > 0">

      <label *ngIf="validFailSku && validFailSku.length > 0">
        {{ 'CreateDo.Msg.FailSkuRecords' | translate }}: {{validFailSku.length}}</label>

    </div>
  </div>
</p-dialog>

<p-dialog header="{{ 'CreateDo.CreateForm.CreateSetting' | translate }}" [(visible)]="displaySettingsDialog" [style]="{width: '300px'}" [modal]="true">
  <div class="settings-container">
    <div class="setting-item">
      <label class="setting-label">{{ 'CreateDo.CreateForm.SkuUppercase' | translate }}</label>
      <div class="switch-container">
        <p-inputSwitch [(ngModel)]="isSkuUppercase" ></p-inputSwitch>
      </div>
      <div class="label-container">
      </div>
    </div>
    <div class="setting-item">
      <label class="setting-label">{{ 'CreateDo.CreateForm.CheckStock' | translate }}</label>
      <div class="switch-container">
        <p-inputSwitch [(ngModel)]="isCheckStock"></p-inputSwitch>
      </div>
      <div class="label-container">
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog header="導入Excel" [(visible)]="displayImportDialog" [style]="{width: '50vw'}" [modal]="true" [baseZIndex]="100">

  <div *ngIf="isImportDialogLoading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="p-fluid">
    <div class="flex justify-content-between">
      <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".xls,.xlsx">
      <button pButton pRipple label="選擇" icon="pi pi-check" class="p-button-success mr-2" (click)="fileInput.click()"></button>
      <button pButton pRipple label="導入Excel" icon="pi pi-upload" class="mr-2" (click)="uploadFile()" [disabled]="!isFileSelected"></button>
      <button pButton pRipple label="下載範本" icon="pi pi-download" class="p-button-secondary" (click)="downloadTemplateBtn()"></button>
    </div>

    <div *ngIf="isFileSelected" class="mt-3">
      File: {{ selectedFileName }}
    </div>

    <div class="settings-container">
      <div class="setting-item">
        <label class="setting-label">{{ 'CreateDo.CreateForm.SkuUppercase' | translate }}</label>
        <div class="switch-container">
          <p-inputSwitch [(ngModel)]="isSkuUppercase" ></p-inputSwitch>
        </div>
        <div class="label-container">
        </div>
      </div>
      <div class="setting-item">
        <label class="setting-label">{{ 'CreateDo.CreateForm.CheckStock' | translate }}</label>
        <div class="switch-container">
          <p-inputSwitch [(ngModel)]="isCheckStock"></p-inputSwitch>
        </div>
        <div class="label-container">
        </div>
      </div>
    </div>

  </div>
</p-dialog>
<help-dock
  [permissionCode]="editPermissionCode"
  [lang]="currentLang">
</help-dock>
